import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';

const apiBase = 'course-occupation';

const endpoints = {
	getAllCourseOccupations: () => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/${apiBase}`,
		method: API_METHODS.GET,
	}),
};

export const getAllCourseOccupations = async () =>
	axiosRequest(endpoints.getAllCourseOccupations());
